// @flow
import { AuthActionTypes } from './constants';

// common success
export const authApiResponseSuccess = (actionType, data) => ({
    type: AuthActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

// common error
export const authApiResponseError = (actionType, error) => ({
    type: AuthActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const updateUser = (userData) => ({
    type: AuthActionTypes.UPDATE_USER,
    payload: userData,
});

export const loginUser = (email, password) => ({
    type: AuthActionTypes.LOGIN_USER,
    payload: { email, password },
});

export const logoutUser = () => ({
    type: AuthActionTypes.LOGOUT_USER,
    payload: {},
});

export const signupUser = (fullname, email, password) => ({
    type: AuthActionTypes.SIGNUP_USER,
    payload: { fullname, email, password },
});

export const forgotPassword = (email) => ({
    type: AuthActionTypes.FORGOT_PASSWORD,
    payload: { email },
});

export const forgotPasswordChange = (email) => ({
    type: AuthActionTypes.FORGOT_PASSWORD_CHANGE,
    payload: { email },
});

export const resetPassword = (token, password) => ({
    type: AuthActionTypes.RESET_PASSWORD,
    payload: { token, password },
});

export const resetAuth = () => ({
    type: AuthActionTypes.RESET,
    payload: {},
});
